import { render, staticRenderFns } from "./period-form-fields.vue?vue&type=template&id=25d5ce2a"
import script from "./period-form-fields.vue?vue&type=script&lang=js"
export * from "./period-form-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports